import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";




const VIDEO_QUERY =
  "(min-width: 1024px) and (prefers-reduced-motion: no-preference)";

function useHeroVideo() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (typeof window?.matchMedia !== "function") return undefined;

    const query = window.matchMedia(VIDEO_QUERY);
    const update = () => setEnabled(query.matches);

    update();
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);

  return enabled;
}

function Hero() {
  const showVideo = useHeroVideo();
  const poster = `${process.env.PUBLIC_URL}/hero-poster.jpg`;

  const slides = [
    "An efficient, modern and commercially-oriented irrigation sector.",
    "Empowering farmers through sustainable water management.",
    "Innovative solutions for a thriving agricultural future.",
  ];

  return (
    <div className="w-full relative lg:mt-[12.4rem] mt-[10rem] h-[600px] overflow-hidden">
      {showVideo ? (
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={`${process.env.PUBLIC_URL}/hero-loop.mp4`}
          poster={poster}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          aria-hidden="true"
        />
      ) : (
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${poster})` }}
          aria-hidden="true"
        />
      )}

      <div className="absolute inset-0 bg-black/45" />

      <Swiper
        modules={[Autoplay]}
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        loop
        allowTouchMove={false}
        className="h-full relative z-10"
      >
        {slides.map((text, index) => (
          <SwiperSlide key={index}>
            <div className="h-full flex items-center justify-center text-white lg:text-[2.25rem] text-[1.75rem] font-[400] font-sora">
              <span className="lg:w-[46.875rem] w-full flex items-center justify-center text-center p-4 drop-shadow-[0_2px_8px_rgba(0,0,0,.6)]">
                {text}
              </span>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Hero;
